<template>
  <div>
    <Table
      :data="profiles"
      :config="config"
      noContentMessage="No profiles yet."
    ></Table>
  </div>
</template>

<script setup lang="ts">
import Table from "../../components/Table.vue";
import { useProfileStore } from "../../store/profiles";
import type { Org, Profile } from "../../common/types/types";
import ellipsize from "ellipsize";

const profileStore = useProfileStore();

const props = defineProps({
  org: {
    type: Object as PropType<Org>,
    required: true,
  },
});

const profiles = computed(() => profileStore.getProfiles(props.org._id));

const mappings = {
  _id: { column: false },
  orgId: { column: false },
  github_username: { column: false },
  first_name: { column: false },
  last_name: { column: false },
  phone: { column: false },
  description: { column: false },
  // phone: { column: false },
  skills: { column: false },
  frontend_frameworks: { column: false },
  backend_frameworks: { column: false },
  resume: { column: false },
  city: { column: false },
  email: { column: false },
  created: { column: false },
  socials: { column: false },
  communication_languages: {
    column: "Communication",
    cell: (profile: Profile) => profile.communication_languages?.join(", "),
  },
  programming_languages: {
    column: "Languages",
    cell: (profile: Profile) => profile.programming_languages?.join(", "),
  },
  
  // parentId: {
  //   column: "Parent",
  //   cell: (profile: Profile) => {
  //     if (!profile.parentId) return;
  //     const parentProfile = store.getProfile(profile.parentId);
  //     return parentProfile.name;
  //   },
  // },
  // scheduledDate: {
  //   order: 1,
  //   column: "Scheduled",
  //   cell: (profile: Profile) =>
  //     `${moment(profile.scheduledDate).format("YYYY-MM-DD")}`,
  // },
};

const actions = [
  {
    title: "Open",
    type: "open",
    to: (item: Profile) => ({
      path: `/profiles/${item._id}`,
    }),
  },
  {
    title: "Delete",
    type: "delete",
    click: async (item: Profile) => {
      await profileStore.deleteProfile(item);
    },
  },
];

const config = {
  mappings: mappings,
  actions: actions,
};
</script>
